import React from "react";

import { DangerouslyHtml } from "@components/item";
import {
  HtmlResponsible,
  ResponsibleAccordionSubTitle,
} from "@pages/casino/CasinoStyling";

import { ResponsibleAccordion } from ".";

const WhenNoLongerGame = ({ data }) => {
  return (
    <ResponsibleAccordion title={data?.field_when_it_s_no_longer_a_game}>
      <ResponsibleAccordionSubTitle>
        <DangerouslyHtml value={data?.field_no_longer_a_game_sub_title} />
      </ResponsibleAccordionSubTitle>

      <HtmlResponsible value={data?.field_no_longer_a_game_desc} />
    </ResponsibleAccordion>
  );
};

export default WhenNoLongerGame;
